import { db } from 'firebase/firebase';
import { collection, getDocs } from 'firebase/firestore';

import { FSCollections } from '@src/constants/database';
import safeExecute from '@src/util/safeExecute';

class TriggerRepository {
  /**
   * Get the path to the triggers subcollection
   * @param {string} organizationId - Organization ID
   * @param {string} divisionId - Division ID
   * @param {string} executionId - Execution ID
   * @returns {string} Path to triggers subcollection
   */
  _getCollectionPath(organizationId, divisionId, executionId) {
    return `${FSCollections.ORGANIZATIONS}/${organizationId}/${FSCollections.DIVISIONS}/${divisionId}/${FSCollections.EXECUTIONS}/${executionId}/${FSCollections.TRIGGERS}`;
  }

  /**
   * Get all triggers from an execution
   * @param {string} organizationId - Organization ID
   * @param {string} divisionId - Division ID
   * @param {string} executionId - Execution ID
   * @returns {Promise<Array<Object>>} Array of triggers
   */
  async getTriggersByExecution(organizationId, divisionId, executionId) {
    return safeExecute(async () => {
      if (!organizationId || !divisionId || !executionId) {
        return [];
      }

      const triggersRef = collection(
        db,
        this._getCollectionPath(organizationId, divisionId, executionId),
      );
      const triggersSnapshot = await getDocs(triggersRef);
      if (triggersSnapshot.empty) {
        return [];
      }

      return triggersSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));
    });
  }
}

export default TriggerRepository;
